import { render, staticRenderFns } from "./DistributionListsHeader.vue?vue&type=template&id=150af594&"
import script from "./DistributionListsHeader.vue?vue&type=script&lang=js&"
export * from "./DistributionListsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DistributionListsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {IconAddPrimary: require('/lasso/components/icons/IconAddPrimary.vue').default,IconList: require('/lasso/components/icons/IconList.vue').default,IconRefresh: require('/lasso/components/icons/IconRefresh.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150af594')) {
      api.createRecord('150af594', component.options)
    } else {
      api.reload('150af594', component.options)
    }
    module.hot.accept("./DistributionListsHeader.vue?vue&type=template&id=150af594&", function () {
      api.rerender('150af594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/distribution-lists/DistributionListsHeader.vue"
export default component.exports